import { IFrame } from '@components/IFrame';

export interface Props {
  url: string;
  portfolioId: number;
  handleFetchPortfolioList: () => void;
  handleIFrameRouteChangingEvent: (data: { path: string }) => void;
}

const EditTransactions = ({
  url,
  portfolioId,
  handleFetchPortfolioList,
  handleIFrameRouteChangingEvent,
}: Props) => {
  // Portfolio details can be updated in the frame, reload the list
  return handleFetchPortfolioList &&
    typeof handleFetchPortfolioList === 'function' ? (
    <IFrame
      id="edit-transactions"
      url={`${url}${portfolioId}`}
      isOtpRequired
      loadingText={'Please wait.. Loading transactions..'}
      unMountOperations={handleFetchPortfolioList}
      handleIFrameRouteChangingEvent={handleIFrameRouteChangingEvent}
    />
  ) : null;
};

export default EditTransactions;
